

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../../Utils/loadingAnimation.js';
import Network from '../../../Utils/network.js';
import { setRegisterDetails, setCurrentPage, setOrderDetails } from '../../../General/Actions';
import NoDataFound from '../../../Utils/noDataFound.js';
import PlanCartComponent from './ActivateAddonCartComponent';
import moment from 'moment';
import MyAccountComponent from '../MyAccountComponent';
import { Button } from 'reactstrap';
import GeneralUtils from '../../../Utils/generalUtils.js';
import PathIcon from '../../../ImageAssets/pathIcon.png';
import Constants from '../../../Utils/constants.json';
import SliderModal from '../../../Utils/sliderModal.js';

class FnFAddonsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            allDeviceDetails: [],
            allAddonDetails: [],
            allComparisonResults: [],
            retainableArray: [],
            isAlreadySelected: false,
            addonArray: [],
            customizeDetails: {
                devices: [],
                addons: [],
                returnDevice: [],
                showCustomizeButton: false
            },
            currentPlanId: "",
            activeAddonIds: "",
            redirectToMyAccount: false,
            feature: "",
            isCartVisibleForMobile: false,
            totalMonthlyCharges: 0,
            redemptionPoint: "0",
            isMoreInfoModalOpen: false,
            content: [],
            heading: "NA",
            moreInfo_name: "",
            currentAddonList: []
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.registerDetails !== prevProps.registerDetails) {
            this.calculateTotalCharge();
        }
    }

    handleInputValueChange(name, event, type) {
        this.state[name]=event;
        this.setState({"dummy":"dummy"})
    };

    calculateTotalCharge() {
        let sum = 0;

        for (var i = 0; i < this.props.registerDetails.customize.addons.length; i++) {
            sum = sum + (parseFloat(this.props.registerDetails.customize.addons[i].offerAmount || 0) * this.props.registerDetails.customize.addons[i].count)
        }

        this.state.totalMonthlyCharges = sum;
        this.setState({ dummy: "dummy" });
    }


    componentDidMount() {
        this.updateWindowDimensions();
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        this.props.setRegisterDetails("isConfirmationReached", false);
        this.getAllAddonIds();
        this.initializeServiceListFromCache(this.props.cache.subscriberInfo);
        this.initialiseRedemptionPoint();
        var headers = {};
        try{
            var recievedFeasibility = this.props.feasibilityResposnse.feasibilityResposne;
            if (recievedFeasibility != null && typeof (recievedFeasibility) != undefined && recievedFeasibility !== "") {
                    if(recievedFeasibility.transport_type_id){
                        headers["TransportType"]= recievedFeasibility.transport_type_id
                    }
                }
            
        } catch(err){

        }

        headers["CustomerType"] = this.props.userDetails.customerType;
        headers["CustomerCategory"] = this.props.userDetails.customerCategory;
        headers["CustomerSubCategory"] = this.props.userDetails.customerSubCategory;
        headers["Channel"] = this.props.locales.channelIdForSCM;
        headers["CONNECTIONTYPE"] = this.props.cache.currentPlanDetails.connectionType;

        window.addEventListener('resize', this.updateWindowDimensions);
        window.addEventListener('scroll', this.handleScroll);

        var dataToSendForAddon = {
            "baseOfferId":  this.state.currentPlanId,
            "header": headers
        }
    
                Network.executeAxios("fetchEligibilityOffers", "POST", dataToSendForAddon, (response) => {
                    var fetchAddoonHeader={
                        "Channel": this.props.locales.channelIdForSCM
                    }
                    Network.executeAxios("fetchAddons", "POST", {"pog": this.props.registerDetails.givenAddress.pog,  "header": fetchAddoonHeader} , (addonResponse) => {
                    var finalAllAddonDetails = [];
                    if (response && response[0]) {
                        finalAllAddonDetails = response;
                    }
                    else {
                        finalAllAddonDetails = []
                    }
    
                    for (var i = 0; i < finalAllAddonDetails.length; i++) {
                        if (finalAllAddonDetails[i].success) {
                            for (var x = 0; x < finalAllAddonDetails[i].success.length; x++) {
                                this.state.addonArray.push(finalAllAddonDetails[i].success[x]);
                            }
                        }
                    }
                    
                    this.initializeAlladdonDetails(finalAllAddonDetails,addonResponse);
                 
                    if (Object.keys(this.props.registerDetails.customize.addons).length == 0) {
                        this.props.setRegisterDetails("customize.addons", []);
                    } else {
                        this.setState({customizeDetails:this.props.registerDetails.customize})
                    }
                    this.getAllServiceDetailsFromBilling();
                });
            })
    }

    getAllServiceDetailsFromBilling(){
        var allServiceIds = this.props.registerDetails.givenAddress.allServiceId
        allServiceIds = allServiceIds.filter((item) => item.serviceId !== this.props.registerDetails.givenAddress.serviceId);
        allServiceIds.map((item, key) => {
            var serviceId= item.serviceId
            Network.executeAxios("viewSubscription", "POST", {"serviceId": serviceId} , (subscriptionResponse) => {
                this.getCurrentAddonList(subscriptionResponse)
                if(key==allServiceIds.length - 1){
                    for(var m=0; m < this.state.activeAddonIds.length; m++){
                        this.state.currentAddonList.push(this.state.activeAddonIds[m])
                    }
                    console.log("CURRENT ADDON LIST>>", this.state.currentAddonList)
                    this.setState({ isLoading: false });
                }
            })
        })

        if(allServiceIds.length == 0)  {
            for(var m=0; m < this.state.activeAddonIds.length; m++){
                this.state.currentAddonList.push(this.state.activeAddonIds[m])
            }
            console.log("CURRENT ADDON LIST>>", this.state.currentAddonList)
            this.setState({ isLoading: false });
        }
    }

    getCurrentAddonList(subscriptionResponse){
        var subscriptionDetails = []
        try{
            subscriptionDetails = subscriptionResponse.BillingSystem.response.dataset.recordset[0].subscriptions
            for(var i=0; i<subscriptionDetails.length; i++){
                if(subscriptionDetails[i].is_base_plan === "0" && subscriptionDetails[i].subscription_type === "0"){
                    if(subscriptionDetails[i].plan_id) this.state.currentAddonList.push(subscriptionDetails[i].plan_id)
                }
            }
        } catch(err){

        }
    }


    moreInfoModalHandler= (dataObject) => {
        if (dataObject.type  === "cancel") {
            this.setState({ isMoreInfoModalOpen: false })
        }
    }

    serviceMoreInfoClicked(event,receivedContent,heading){
        this.setState({isMoreInfoModalOpen: false})
        event.stopPropagation();
        this.setState({
            content : receivedContent,
            heading : heading,
            moreInfo_name: "",
            isMoreInfoModalOpen : true
        })
    }

    initialiseRedemptionPoint(){
            var redemptionPoint = "0";
            var redemptionPoint = "0";
            try{
                var ccmConfig = this.props.cache.ccmConfigResponse;
                redemptionPoint =  ccmConfig["_embedded"].configs[0].configValue;
            } catch(err){
    
            }
               this.setState({"redemptionPoint":redemptionPoint})
        }

    tabLinkClicked(type){
        if(type === "manageService"){
            this.setState({feature: "addAddon"})
        }
        this.setState({redirectToMyAccount:true})
    }

    getAllAddonIds(){
        var activeAddonIds = [];
        for(var i=0;i<this.props.registerDetails.activeAddons.length; i++){
            activeAddonIds.push(this.props.registerDetails.activeAddons[i].planId)
        }
        this.state.activeAddonIds = activeAddonIds;
    }

    initializeServiceListFromCache(receivedSubscriberInfoResponse) {
        var reduxCache = this.props.cache;
        console.log("reduxCache",reduxCache)
        var maBalance = "0";
        var serviceCode = ""
        var serviceName = ""
        try {
            var receivedResponse = reduxCache.querySubscriberResponse;
            var params = receivedResponse.profile_info.basic_details;
            var finalContactNumber = "";
            var finalEmailId = "";
            var finalFirstName = "";
            var finalLastName = "";
            var finalProfileId = "";
            var finalPin = "";
            var finalSsn = "";
            for (var i = 0; i < params.length; i++) {
                if (params[i].id === "first_name") {
                    finalFirstName = params[i].value;
                }
                if (params[i].id === "last_name") {
                    finalLastName = params[i].value;
                }
                if (params[i].id === "contact_number_1") {
                    finalContactNumber = params[i].value;
                }
                if (params[i].id === "contact_email_id") {
                    finalEmailId = params[i].value;
                }
                if (params[i].id === "profile_id") {
                    finalProfileId = params[i].value;
                }
                if(params[i].id === "pin"){
                    finalPin = params[i].value;
                }
                if(params[i].id === "ssn_serial_no"){
                    finalSsn = params[i].value;
                }
            }
            this.state.firstName = finalFirstName
            this.state.lastName = finalLastName
            this.state.contactEmailAddress = finalEmailId
            this.state.contactNumber = finalContactNumber
            this.state.profileId = finalProfileId
            this.state.pin = finalPin
            this.state.ssn = finalSsn

        } catch (err) {

        }
        try {
            var serviceParams = receivedSubscriberInfoResponse.service_info.basic_details;
            var finalPlanId = "";
            var finalPlanName = "";
        
            for (var j = 0; j < serviceParams.length; j++) {
                if (serviceParams[j].id === "rate_plan_id") {
                    finalPlanId = serviceParams[j].value;
                }
                if (serviceParams[j].id === "rate_plan_name") {
                    finalPlanName = serviceParams[j].value;
                }
                if (serviceParams[j].id === "maBalance") {
                    maBalance = serviceParams[j].value
                }  
                if (serviceParams[j].id === "service_code") {
                    serviceCode = serviceParams[j].value
                }
                if (serviceParams[j].id === "service_name") {
                    serviceName = serviceParams[j].value
                }
            }
            this.state.currentPlanId = finalPlanId
            this.state.currentPlanName = finalPlanName
            this.state.maBalance = GeneralUtils.formatNumberToStandardForm(maBalance)
            console.log("maBalance>>>>>",maBalance)
        } catch (err) {

        }
        try{
            var accountData = receivedResponse.account_info.basic_details;
            var accountId = "";
            for (var k = 0; k < accountData.length; k++) {
                if (accountData[k].id === "account_id") {
                    accountId = accountData[k].value;
                }
            }
            this.state.accountId = accountId
        } catch(err){
            accountData=[]
        }

        
        this.setState({
            dummy: "dummy"
        }, () => {
            var contactDetails = {}
            contactDetails["firstName"] = this.state.firstName;
            contactDetails["lastName"] = this.state.lastName;
            contactDetails["contactEmailAddress"] = this.state.contactEmailAddress;
            contactDetails["contactNumber"] = this.state.contactNumber;
            contactDetails["profileId"] = this.state.profileId;
            contactDetails["accountId"] = this.state.accountId;
            contactDetails["currentPlanId"] = this.state.currentPlanId;
            //contactDetails["currentPlanId"]="Italk500";
            contactDetails["currentPlanName"] = this.state.currentPlanName;
            contactDetails["serviceId"] = localStorage.getItem("currentServiceId")
            contactDetails["pin"] = this.state.pin;
            contactDetails["ssn"] = this.state.ssn;
            contactDetails["serviceCode"] = serviceCode;
            contactDetails["serviceName"] = serviceName;
            this.props.setRegisterDetails("confirmation", contactDetails);
            this.props.setRegisterDetails("generalResponse.maBalance",this.state.maBalance)
        })

    }



    initializeAlladdonDetails(receivedResponse, stdAddonResponse) {
        var stdAddonArr = stdAddonResponse
        // for (var p = 0; p < stdAddonResponse.length; p++) {
        //     if (stdAddonResponse[p].success) {
        //         for (var q = 0; q < stdAddonResponse[p].success.length; q++) {
        //             stdAddonArr.push(stdAddonResponse[p].success[q]);
        //         }
        //     }
        // }
    
        var eligibilityOffers = [];
        try {
            if (Array.isArray(receivedResponse)) {
                for (var x = 0; x < receivedResponse.length; x++) {
                    eligibilityOffers.push(receivedResponse[x].eligibilityOffers)
                }
            }
        } catch (err) {
            eligibilityOffers = [];
        }

        var finaleligibilityOffers = eligibilityOffers.reduce((r, e) => (r.push(...e), r), []);
      
        var finalProductOfferingsArray = [];
        var allIncomaptibleIds = [];
        var incompatibleArrUpdated = [];
        for (var i = 0; i < finaleligibilityOffers.length; i++) {
            var productOfferingsArray = [];
            var incompatibleArr = [];
            try {
                if (finaleligibilityOffers[i].productOfferings) {
                    var eligibilityTypeId = ""
                    if(finaleligibilityOffers[i].eligibilityType && finaleligibilityOffers[i].eligibilityType.id){
                        eligibilityTypeId = finaleligibilityOffers[i].eligibilityType.id;
                    }
                    if(eligibilityTypeId === "7"){
                        incompatibleArr.push(finaleligibilityOffers[i].productOfferings)
                        incompatibleArrUpdated = incompatibleArr.reduce((r, e) => (r.push(...e), r), []);
                    } else { 
                        productOfferingsArray.push(finaleligibilityOffers[i].productOfferings);
                        var productOfferingsArrayUpdated = productOfferingsArray.reduce((r, e) => (r.push(...e), r), []);
                        for(var e=0; e< productOfferingsArrayUpdated.length; e++){
                            var tariffArr = [];
                            var bucketDetailsArr = [];
                            var currentObj = productOfferingsArrayUpdated[e]
                            if(currentObj.ratingParameters && currentObj.ratingParameters[0] && currentObj.ratingParameters[0].meteredRates &&
                                currentObj.ratingParameters[0].meteredRates[0]){
                                    var currentMeteredRatesObj = currentObj.ratingParameters[0].meteredRates;
                                    for(var g=0; g<currentMeteredRatesObj.length; g++){
                                        let temp = {
                                            "name": currentMeteredRatesObj[g].name
                                        }
                                        tariffArr.push(temp)
                                    }
                            }
                            if(currentObj.bucketDetails && currentObj.bucketDetails[0]){
                                for(var f=0; f< currentObj.bucketDetails.length; f++){
                                    var currentBucket = currentObj.bucketDetails[f];
                                    if(currentBucket.counter && currentBucket.counter.serviceType && currentBucket.counter && currentBucket.counter.serviceType.name){
                                        let temp = {
                                            "name": currentBucket.counter.serviceType.name +" - "+ currentBucket.counter.name
                                        }
                                        bucketDetailsArr.push(temp);
                                    }
                                }
                            }
                            currentObj["tariffArr"] = tariffArr;
                            currentObj["bucketDetailsArr"] = bucketDetailsArr;
                        }
                    }
                    var fnfAddonArr = []
                    for(var m=0; m<productOfferingsArrayUpdated.length; m++){
                        if(productOfferingsArrayUpdated[m] && productOfferingsArrayUpdated[m].ratingParameters && productOfferingsArrayUpdated[m].ratingParameters[0] ){
                            var fnfratingParam = productOfferingsArrayUpdated[m].ratingParameters[0].friendsAndFamily;
                            if(fnfratingParam === "true"){
                                fnfAddonArr.push(productOfferingsArrayUpdated[m]);
                            }
                        }
                    }
                     let temp = {
                         "groupMaxQuantity" : finaleligibilityOffers[i].maxQuantity,
                         "groupMinQuantity" : finaleligibilityOffers[i].minQuantity,
                         "productOfferings" : fnfAddonArr
                     }
                     finalProductOfferingsArray.push(temp)
                    }
                }
            catch (err) { }
        }

           //removing incompatible addons from standalone
        for(var n=0; n< incompatibleArrUpdated.length; n++){
            allIncomaptibleIds.push(incompatibleArrUpdated[n].id);
        }
        var finalStandaloneArr = []
        for(var b=0; b<stdAddonArr.length; b++){
            if(allIncomaptibleIds.includes(stdAddonArr[b].id)){

            }else {
                finalStandaloneArr.push(stdAddonArr[b])
            }
        }

        if(finalStandaloneArr.length > 0) {
            var srdProductOfferingArr = []
            for(var q=0; q< finalStandaloneArr.length; q++){
                if(finalStandaloneArr[q] && finalStandaloneArr[q].ratingParameters[0]){
                    var fnfratingParam = finalStandaloneArr[q].ratingParameters[0].friendsAndFamily;
                    if(fnfratingParam === "true"){
                        srdProductOfferingArr.push(finalStandaloneArr[q]);
                    }
                }
            }
            for(var e=0; e< srdProductOfferingArr.length; e++){
                var tariffArr = [];
                var bucketDetailsArr = [];
                var currentObj = srdProductOfferingArr[e]
                if(currentObj.ratingParameters && currentObj.ratingParameters[0] && currentObj.ratingParameters[0].meteredRates &&
                    currentObj.ratingParameters[0].meteredRates[0]){
                        var currentMeteredRatesObj = currentObj.ratingParameters[0].meteredRates;
                        for(var g=0; g<currentMeteredRatesObj.length; g++){
                            let temp = {
                                "name": currentMeteredRatesObj[g].name
                            }
                            tariffArr.push(temp)
                        }
                }
                if(currentObj.bucketDetails && currentObj.bucketDetails[0]){
                    for(var f=0; f< currentObj.bucketDetails.length; f++){
                        var currentBucket = currentObj.bucketDetails[f];
                        if(currentBucket.counter && currentBucket.counter.serviceType && currentBucket.counter && currentBucket.counter.serviceType.name){
                            let temp = {
                                "name": currentBucket.counter.serviceType.name +" - "+ currentBucket.counter.name
                            }
                            bucketDetailsArr.push(temp);
                        }
                    }
                }
                currentObj["tariffArr"] = tariffArr;
                currentObj["bucketDetailsArr"] = bucketDetailsArr;
            }
            let tempObj = {
                "groupMaxQuantity" : "1",
                "groupMinQuantity" : "1",
                "productOfferings" : srdProductOfferingArr
            }
            finalProductOfferingsArray.push(tempObj)
        }
    
        this.state.allAddonDetails = finalProductOfferingsArray;
        console.log("finalProductOfferingsArray",finalProductOfferingsArray)
        this.setState({ dummy: "dummy" });
    }

    selectAddonClickedForAddon(receivedData, minCount) {
        this.state.customizeDetails.addons=[]
        try {
            receivedData = JSON.parse(decodeURIComponent(receivedData))
                if(parseInt(minCount)>0){
                    receivedData["count"] = minCount;
                } else {
                    receivedData["count"] = 1;
                }
            receivedData["showCustomizeButton"] = true;
            this.state.customizeDetails.addons.push(receivedData);
            this.props.setRegisterDetails("customize.addons", this.state.customizeDetails.addons);
            this.setState({ showCustomizeButton: true });
          
        }
        catch (err) {
            receivedData = []
        }
    }


    removeAddonClickedForAddon(receivedData,allAddonDetail) {
        try {
            var addonIndexToBeRemoved = "";
            var temp = []
            Object.assign(temp, this.state.customizeDetails.addons);
            for (var i = 0; i < temp.length; i++) {
                if (temp[i].id === receivedData) {
                    addonIndexToBeRemoved = i;
                }
            }
            temp.splice(addonIndexToBeRemoved, 1);
            this.state.customizeDetails.addons = temp;
            this.props.setRegisterDetails("customize.addons", this.state.customizeDetails.addons);
            this.state.showCustomizeButton = false;
            this.setState({ "dummy": "dummy" });
        }
        catch (err) {
            receivedData = []
        }
    }

    populateAllAddons() {
        const allAddonDetails = this.state.allAddonDetails.map((itemArray, keyCheck) => {
            var currentItemArray = []
            if(itemArray && itemArray.productOfferings && itemArray.productOfferings[0])
                currentItemArray = itemArray.productOfferings;
            return currentItemArray.map((item, key) => {
            try{
                var productPrice = {}
                if (item.productOfferingPrice[0]) {
                    for (var i = 0; i < item.productOfferingPrice.length; i++) {
                        if(item.productOfferingPrice[i] && item.productOfferingPrice[i].priceCategory){
                            //if (item.productOfferingPrice[i].priceCategory.id === "0") {
                                productPrice = item.productOfferingPrice[i];
                            //}
                        }
                       
                    }
                }
            
              //tier based price
              var addonPrice = "0";
              var addonCount = 1;
              if(productPrice && productPrice.tierbased && productPrice.tierbased == true){
                  for(var c=0; c< this.state.currentAddonList.length; c++){
                      if(item.id === this.state.currentAddonList[c]){
                          addonCount = addonCount + 1;
                      }
                  }
  
                  for (var k = 0; k < this.state.customizeDetails.addons.length; k++) {
                          addonCount = parseInt(addonCount) + (parseInt(this.state.customizeDetails.addons[k].count))
                      }
  
                  for(var d=0; d< productPrice.tiers.length; d++){
                      var currentTempObj = productPrice.tiers[d];
                      if(addonCount >= currentTempObj.startRange && addonCount <= currentTempObj.endRange){
                          addonPrice = currentTempObj.price;   
                          break;   
                      } else {
                          addonPrice = productPrice.price;
                      }
                  }
              } else {
                  addonPrice = productPrice.price;
              }
  
              var rewardPoint = parseFloat(addonPrice) * parseInt(this.state.redemptionPoint)
  
              var packageAmount = ""
              var packageAmount_sup = ""
              try{
                  var price = addonPrice;
                  price = price.split(".");
                  packageAmount = price[0]
                  if(price.length > 1){
                      packageAmount_sup = price[1];
                  } else{
                      packageAmount_sup = "00"
                  }
              } catch(err){
                  packageAmount = 0
                  packageAmount_sup = "00"
              }
  
            var contextValue = ""
            try {
                if (item.productOfferingPrice[0].rules[0].conditions[0]) {
                    for (var y = 0; y < item.productOfferingPrice[0].rules[0].conditions.length; y++) {
                        if (item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].name === "VideoFormat") {
                            contextValue = item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].value
                        }
                    }

                }
            } catch (err) {
                contextValue = ""
            }

            var productSubtype = {}
            try {
                if (item.productSpecifications[0]) {
                    productSubtype = item.productSpecifications[0].subType;
                }
            } catch (err) {
                productSubtype = {}
            }
            var poType = {}
            try {
                if (item.productSpecifications[0]) {
                    poType = item.productSpecifications[0].type;
                }
            } catch (err) {
                poType = {}
            }

            var productSpecifications = {}
            try {
                if (item.productSpecifications[0]) {
                    productSpecifications = item.productSpecifications[0];
                }
            } catch (err) {
                productSpecifications = {}
            }

            var productOfferGroup = {}
            try {
                if (item.productOfferGroup) {
                    productOfferGroup = item.productOfferGroup;
                }
            } catch (err) {
                productOfferGroup = {}
            }

            var connectionType = "POSTPAID"
            if(this.props.cache.currentPlanDetails.connectionType === this.props.locales.connectionTypeForPrepaid)
            {connectionType = "PREPAID"}

            var skipSom = "false";
            var cfss = []
            try {
               for(var m = 0; m < item.productSpecifications.length; m++){
                   var currentPS = item.productSpecifications[m];
                   for(var n = 0; n< currentPS.cfss.length; n++){
                        var currentObjCfss = currentPS.cfss[n];
                        if(currentPS.releationships.length > 0){
                            for(var o = 0; o < currentPS.releationships.length; o++){
                                var relationObj =  currentPS.releationships[0];
                                if(relationObj && relationObj.targetObject && currentObjCfss.id === relationObj.targetObject.id){
                                    if(relationObj && relationObj.skipSOM && relationObj.skipSOM == "true"){
                                        skipSom = "true";
                                    }
                                }
                            }
                        }
                        currentObjCfss["skip_som"] = skipSom
                        cfss.push(currentObjCfss)
                        delete currentObjCfss.validFor
                   }
               }
            } catch (err) {
                cfss = []
            }
            
            var cfssArray = []
            for (var x = 0; x < cfss.length; x++) {
                let temp = {
                    "id": cfss[x].id,
                    "name": cfss[x].name,
                    "href": cfss[x].href,
                    "service_type": cfss[x].serviceType,
                    "service_class": cfss[x].serviceClass,
                    "transport_type": cfss[x].transportType,
                    "service_category": cfss[x].serviceCategory,
                    "characteristics": cfss[x].characteristics,
                    "skip_som": cfss[x].skip_som
                }
                cfssArray.push(temp);
            }

            var isRedeemable=false;
            for(var y=0;y<cfssArray.length;y++){
                if(cfssArray[y].characteristics){
                    var characteristics=cfssArray[y].characteristics;
                    for(var k=0;k<characteristics.length;k++){
                        if(characteristics[k].name && characteristics[k].value){
                            if(characteristics[k].name=="isRedeemable" && characteristics[k].value=="true"){
                                isRedeemable=true;
                            }
                        }
                    }
                }
            }

            var MinLoyaltyPoints="0";
            for(var y=0;y<cfssArray.length;y++){
                if(cfssArray[y].characteristics){
                    var characteristics=cfssArray[y].characteristics;
                    for(var k=0;k<characteristics.length;k++){
                        if(characteristics[k].name && characteristics[k].value){
                            if(characteristics[k].name=="MinLoyaltyPoints"){
                                MinLoyaltyPoints=characteristics[k].value
                            }
                        }
                    }
                }
            }


            var activate_addon_upon_use = "false";
            if(item.ratingParameters && item.ratingParameters[0]){
                activate_addon_upon_use = item.ratingParameters[0].activateaddonuponuse;
            }

            var subscriptionCharges = [];
            var planValidity = "";
            var effective_date = moment().format("MM/DD/YYYY HH:mm:ss")
            var expiry_date = moment().add(103, 'years').format("MM/DD/YYYY HH:mm:ss")
            if(item.ratingParameters && item.ratingParameters[0]){
                var ratingParam = item.ratingParameters[0]
                if(item.productOfferingPrice[0].priceMode.id == "1"){
                    if(ratingParam && ratingParam.subscriptionPeriod){
                        var subscriptionPeriod = parseInt(ratingParam.subscriptionPeriod)
                        if(ratingParam.subscriptionPeriodType.id == "0"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'days');
                            planValidity = subscriptionPeriod + " days"
                        } else if(ratingParam.subscriptionPeriodType.id === "1"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'weeks');
                            planValidity = subscriptionPeriod + " weeks"
                        } else if(ratingParam.subscriptionPeriodType.id === "2"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'months');
                            planValidity = subscriptionPeriod + " months"
                        } else if(ratingParam.subscriptionPeriodType.id === "3"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'years');
                            planValidity = subscriptionPeriod + " years"
                        } else if(ratingParam.subscriptionPeriodType.id === "4"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'hours');
                            planValidity = subscriptionPeriod + " hours"
                        }
                    }
                }
            }

            expiry_date = moment(expiry_date).format("MM/DD/YYYY HH:mm:ss") 

            var subscriptionCharges = []
            for (var k = 0; k < item.productOfferingPrice.length; k++) {
                var prorata_flags = ""
                try {
                    var prorataEnabledInSuspension = item.productOfferingPrice[k].prorataEnabledInSuspension ? "1" : "0";
                    var prorataEnabledInTermination = item.productOfferingPrice[k].prorataEnabledInTermination ? "1" : "0";
                    var prorataEnabledInPlanChange = item.productOfferingPrice[k].prorataEnabledInPlanChange ? "1" : "0";
                    var prorataEnabledInActivation = item.productOfferingPrice[k].prorataEnabledInActivation ? "1" : "0";
                    prorata_flags = prorataEnabledInActivation + prorataEnabledInTermination + prorataEnabledInSuspension + prorataEnabledInPlanChange
                } catch (err) {
                    prorata_flags = ""
                }
                var factor = ""
                if (item.productOfferingPrice[k].factor) {
                    factor = item.productOfferingPrice[k].factor
                }
                var frequency = ""
                if (item.productOfferingPrice[k].frequency) {
                    frequency = item.productOfferingPrice[k].frequency.id
                }

                let tempCharges = {}
                try {
                    tempCharges = {
                        "upc_charge_id": item.productOfferingPrice[k].id,
                        "charge_type": item.productOfferingPrice[k].priceMode.id,
                        "charge_name": item.productOfferingPrice[k].name,
                        "charge_desc": item.productOfferingPrice[k].description,
                        "start_date": moment().format("MM/DD/YYYY HH:mm:ss"),
                        "end_date": expiry_date,
                        "charge_tax": item.productOfferingPrice[k].priceCode.taxCategoryId,
                        "charge_validity": "",
                        "charge_category": item.productOfferingPrice[k].priceCategory.billingChargeType.id,
                        "charge_id": item.id,
                        "discount_type": item.productOfferingPrice[k].priceType.name,
                        "epc_enabled": "1",
                        "quantity_based": "",
                        "charge_classification": "",
                        "charge_amount_type": item.productOfferingPrice[k].priceType.name,
                        "charge_frequency": frequency,
                        "charge_factor": factor,
                        "is_prorata": item.productOfferingPrice[k].prorataEnable ? "1" : "0",
                        "prorata_flags": prorata_flags,
                        "charge_code": item.productOfferingPrice[k].priceCode.id
                    }
                    if(connectionType === "POSTPAID"){
                        tempCharges["charge_amount"] = addonPrice
                        tempCharges["total_charge"] = addonPrice
                    } else {
                        tempCharges["charge_amount"] = "0"
                        tempCharges["total_charge"] = "0"
                    }
                } catch (err) {
                    tempCharges = {}
                }
                if(Object.keys(tempCharges).length > 0)
                subscriptionCharges.push(tempCharges)
            }

            var pogIdFromResponse = item.productOfferGroup.id;
            var productFamilyIdFromResponse = item.productOfferGroup.productFamily.id
           
            var currentAddonDataTemp = {};
            currentAddonDataTemp["id"] = item["id"];
            currentAddonDataTemp["name"] = item["marketingDescription"];
            currentAddonDataTemp["description"] = item["description"] || "NA";
            currentAddonDataTemp["offerAmount"] = addonPrice || 0;
            currentAddonDataTemp["productSubtype"] = productSubtype.id || 0;
            currentAddonDataTemp["effective_date"] = effective_date;
            currentAddonDataTemp["expiry_date"] = expiry_date;
            currentAddonDataTemp["productId"] = productOfferGroup.id;
            currentAddonDataTemp["productName"] = productOfferGroup.name;
            currentAddonDataTemp["poType"] = poType.id;
            currentAddonDataTemp["subscriptionCharges"] = subscriptionCharges;
            currentAddonDataTemp["contextValue"] = contextValue;
            currentAddonDataTemp["po_sub_type"] = "0";
            currentAddonDataTemp["pogIdFromResponse"] = pogIdFromResponse;
            currentAddonDataTemp["eligibilityType"] = item.eligibilityType || 0;
            currentAddonDataTemp["productFamilyIdFromResponse"] = productFamilyIdFromResponse;
            currentAddonDataTemp["isRedeemable"] = isRedeemable;
            currentAddonDataTemp["MinLoyaltyPoints"] = MinLoyaltyPoints;
            currentAddonDataTemp["connectionType"] = connectionType;
            currentAddonDataTemp["activate_addon_upon_use"] = activate_addon_upon_use;
            if(addonCount == 1) {
                currentAddonDataTemp["plan_type"] = "1";
            } else {
                currentAddonDataTemp["plan_type"] = "2";
            }
            if (cfssArray.length > 0) {
                currentAddonDataTemp["cfss"] = cfssArray;
            }
        }
            catch(err){
                currentAddonDataTemp = {}
            }
            var currentAddonData = encodeURIComponent(JSON.stringify(currentAddonDataTemp));
          
            var isSelected = false;
            for (var l = 0; l < this.state.customizeDetails.addons.length; l++) {
                if (item["id"] === this.state.customizeDetails.addons[l].id) {
                    isSelected = true
                }
            }
          
            if(this.state.activeAddonIds.includes(item.id)){

            }
          
                return (
                    <div className="col-md-6 p-0" key={key}>
                        <div className={isSelected ? "allAddonDetailForAddon align-items-center mb-3 row m-0 pb-2 px-2" : "allAddonDetailForAddonInactive align-items-center mb-3 row m-0 pb-2 px-2"}
                            onClick={() => isSelected ? this.removeAddonClickedForAddon(item.id, itemArray) : this.selectAddonClickedForAddon(currentAddonData, item.minQuantity, itemArray)} >
                            <div className="col-md-12" style={{ height: 30 }}>{isSelected ?
                                <div className="selectedBadge">
                                   {this.props.locales.selectedLabelAddons}
                                </div>
                                :
                                <div>
                                </div>
                            }
                            </div>
                         
                            <div className="col-md-12 row p-0 px-2 m-0 pt-2 justify-content-between">
                                <div className="nameContainer col-md-9 p-0">{item.marketingDescription}</div>
                                <div className="col-md-3 p-0 text-right d-flex justify-content-end" style={{ color: '#231F20', fontWeight: 500, position: 'relative' }}>
                                    <span style={{ fontSize: 12 }}>{Constants.dollarSign}</span><span style={{ lineHeight: '25px', fontSize: 28 }}>{packageAmount}</span><span style={{ fontSize: 12 }}>{packageAmount_sup}/mo.</span>
                                    {isRedeemable ?
                                        <div className="col-md-12 row p-0 justify-content-end d-none d-sm-block" style={{color: '#FF8F18', fontSize: 12,position:'absolute', right: '20%', top: '50%'}}>or {rewardPoint} pts</div>
                                    : null }
                                </div>
                            </div>
                            <div className="col-md-12 row p-0 px-2 m-0">
                                <div className="nameContainerDesc">{item.description || "NA"}</div>
                            </div>
                            {planValidity !== "" ?
                            <div className="col-md-12 row p-0 px-2 m-0 pb-2">
                                <div className="labelsInMyAccountContainer">Plan Validity: <span className="nameContainerDesc" style={{display: 'inline'}}>{planValidity}</span></div>
                            </div>
                        : 
                            <div className="col-md-12 row p-0 px-2 m-0 pb-2" style={{visibility: 'hidden'}}> 
                                <div className="labelsInMyAccountContainer">Plan Validity: <span className="nameContainerDesc" style={{display: 'inline'}}>{planValidity}</span></div>
                            </div> }
                        <div className="col-md-12 p-0 px-2 m-0">
                            {item.tariffArr.length > 0 ?
                            <div className="col-md-12 moreInfo p-0" onClick={(event) => { this.serviceMoreInfoClicked(event,item.tariffArr,this.props.locales.tariffHeadingInModal) }}>
                                View Tariff Details
                            </div>
                        : 
                            <div className="col-md-12 moreInfo p-0" style={{visibility: 'hidden'}}>
                                View Tariff Details
                            </div>
                        }
                        {item.bucketDetailsArr.length > 0 ?
                            <div className="col-md-12 moreInfo pt-1 p-0" onClick={(event) => { this.serviceMoreInfoClicked(event,item.bucketDetailsArr,this.props.locales.bucketDetailsHeadingInModal) }}>
                                View Bucket Details
                            </div>
                        : 
                            <div className="col-md-12 moreInfo p-0" style={{visibility: 'hidden'}}>
                                View Bucket Details
                            </div> 
                        }
                        </div>
                        </div>
                    </div>
                );
                        
                    });
                })

        if (allAddonDetails.length > 0) {
             return (<div className="allAddonDetailContainer row col-md-12 p-0 mx-auto">{allAddonDetails}</div>);
        } else {
            return (<div className="allAddonDetailContainer row m-0 col-md-12 p-0 mx-auto"><div className="col-md-12 mx-auto mt-3 row p-0"><NoDataFound content="No add-ons are available" /></div></div>);
        }
    }

    arrowButtonClicked(type){
        this.setState({isCartVisibleForMobile:type})
    }

    cartNextButtonClicked(){
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        this.props.setCurrentPage("pageName", "confirmation"); 
    }

   
    updateWindowDimensions = () => {
        //this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    render() {
        if (this.state.redirectToMyAccount) {
            return (
                <MyAccountComponent feature={this.state.feature} />
            )
        }

        return (
            <div id="customizePartTopDivContainer">
                 {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : this.componentContent()}
            </div>
        );
    }

    componentContent() {
        if(this.state.isCartVisibleForMobile == false){
            const customizeComponentStyle = { minHeight: this.state.windowHeight + 'px' ,width:'92%'};
            return (
                <div className="mb-5">
                <div className="col-md-12 p-0 ml-auto" style={customizeComponentStyle}>
                     <div className="d-flex justify-content-between mt-5 mb-4 pt-sm-0 pt-4" style={{ height: 65, position: 'relative' }}>
                     <div className="text-left">
                            <div className="" style={{color: '#33495F' ,fontSize:24,fontWeight:500}}>{this.props.locales.servicesTextForTabLinkManageService}</div>
                            <div className="d-flex" style={{ color: '#33495F' }}>
                                <div className="" style={{ cursor: 'pointer', fontSize: 18 }} onClick={() => this.tabLinkClicked('myAccount')}>{this.props.locales.myAccountTextInTabLinkManageService} &nbsp;&nbsp;></div>
                                <div className="ml-3" style={{ cursor: 'pointer', fontSize: 18,fontWeight:500 }} onClick={() => this.tabLinkClicked('manageService')}>{this.props.locales.fnfTextInTabLinkManageService}</div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12 row changePlanCustomizePart m-0 p-0">
                        <div className="col-md-8 pb-4 p-0 pr-3">
                            <div className="col-md-12 p-0">
                                <div className="col-md-12 p-0 pr-3"><div className="col-md-12 pb-2 p-0 mb-4 mt-sm-0 mt-4" style={{color:'#33495F',fontSize:18,fontWeight:500,borderBottom:'1px solid #D6D6D6'}}>{this.props.locales.chooseAddonsInFnFAddons}</div></div>
                                <div className="col-md-12 pb-4 pr-0 p-0">
                                    <div className="addonDetailsContainer col-md-12 p-0 m-0">
                                        <div className="col-md-12 row p-0 m-0">{this.populateAllAddons()}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4  pb-4 d-none d-sm-block">
                                <PlanCartComponent/>
                        </div>
                        <SliderModal
                    isVisible={this.state.isMoreInfoModalOpen}
                    uniqueModalReferenceId="moreInfoPart"
                    mainHeading={this.state.heading}
                    isResetButtonVisible={false}
                    leftPartFlexValue={1.5}
                    rightPartFlexValue={1}
                    contentPartBackgroundColor="#F5F8FB"
                    isSubmitButtonVisible={false}
                    isValidationRequired = {false}
                    callback={this.moreInfoModalHandler}
                >
                     <div className="col-md-12">
                        <div className="col-md-12 px-2">
                            <div className="col-md-12 py-3 p-0" id="phoneMumPart">
                                <div className="form-group col-md-12 p-0 mb-1">
                                    <label className="formGroup_label">Search</label>
                                    <div className="input-group">
                                        <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data typeNumber"
                                            name="moreInfo_name" autoComplete="off" value={this.state.moreInfo_name} style={{border: '1px solid #EAEDF0',borderRadius:4}}
                                            onChange={(event) => {
                                                this.handleInputValueChange("moreInfo_name", event.target.value)
                                            }}
                                        />
                                      
                                    </div>
                                    <div className="errorDesc"></div>
                                </div>
                            </div>
                          
                        {this.state.content
                                .filter(item => {
                                    if (!this.state.moreInfo_name) return true;
                                    if (item.name.toLocaleLowerCase().includes(this.state.moreInfo_name.toLocaleLowerCase())) {
                                        return true;
                                    }
                                    return false;
                                })
                                .map((item, key) => {
                                    return(
                                        <div className="col-md-12 row p-0 pb-2 popupContent mx-auto px-1" key={key}>
                                            <div className="col-md-1 p-0">{key+1}</div>
                                            <div className="col-md-11 p-0">{item.name}</div>
                                        </div>
                                    )
                                })
                       }

                        </div>
                    </div>
                </SliderModal>

                    </div>
                    </div>
    
              {Object.keys(this.props.registerDetails.customize.addons).length > 0 ?
                <div className="d-block d-md-none bottomCartPartForMobile" style={{bottom:0}}>
                    <div className="d-flex flex-column">
                        <div className="d-flex justify-content-center pt-2"><img src={PathIcon} alt="" onClick={() => { this.arrowButtonClicked(true) }}/></div>
                        <div className="d-flex align-items-center justify-content-between px-3 pb-1">
                            <div className="amountContainer">
                                    <div>{this.props.locales.amountToPayForMobViewAllAddons}</div>
                                    <div style={{fontSize: 28}}>{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(this.state.totalMonthlyCharges)}</div>
                            </div>
                            <div>
                            <Button className="nextButton" onClick={() => { this.cartNextButtonClicked() }}>
                               {this.props.locales.nextBtnTxtMobViewAllAddonsComponent}
                            </Button>
                            </div>
                        </div>
                    </div>
                </div>
                : null }

                </div>
            );
        } else {
            const customizeComponentStyle = { minHeight: this.state.windowHeight + 'px' ,width:'100%', marginTop: '110px'};
            return(
            <div className="mb-5 mx-4 col-12 mx-auto">
            <div className="col-12 p-0" style={customizeComponentStyle}>
                <div className="col-12  pb-4 m-0 mx-auto px-0">
                    <PlanCartComponent/>
                </div>
            </div>
            {Object.keys(this.props.registerDetails.customize.addons).length > 0 ?
                <div className="d-block d-md-none bottomCartPartForMobile" style={{top:0}}>
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-center justify-content-between px-3 pt-1">
                        <div className="amountContainer">
                                <div>{this.props.locales.amountToPayForMobViewAllAddons}</div>
                                <div style={{fontSize: 28}}>{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(this.state.totalMonthlyCharges)}</div>
                        </div>
                        <div>
                        <Button className="nextButton" onClick={() => { this.cartNextButtonClicked() }}>
                            {this.props.locales.nextBtnTxtMobViewAllAddonsComponent}
                        </Button>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center pb-2"><img className="rotate180" src={PathIcon} alt="" onClick={() => { this.arrowButtonClicked(false) }} /></div>
                </div>
            </div>
        : null }

            </div>
        );
        }
       
    }
}


const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        registerDetails: state.registerDetails,
        currentPage: state.currentPage,
        feasibilityResposnse: state.feasibilityResposnse,
        contextParameters: state.contextParameters,
        cache: state.cache,
        userDetails: state.userDetails
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        },
        setCurrentPage: function (key, payload) {
            dispatch(setCurrentPage(key, payload));
        },
        setOrderDetails: function (key, payload) {
            dispatch(setOrderDetails(key, payload));
        }
    }
}

const FnFAddonsComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(FnFAddonsComponent)


export default FnFAddonsComponentContainer;
